import React from 'react';

import LinksDropdown from "../components/LinksDropdown/LinksDropdown"
import ProductFinder from "../components/ProductFinder/ProductFinder"

export const components = {
    LinksDropdown,
    ProductFinder
}

export default components;
